module.exports = __webpack_public_path__ + "static/media/something-went-wrong-icon.a9e13f06.svg";